import { useCoverageToolModalProvider } from '../../coverageToolModal.context';

const EnableDebug = () => {
  const { printContext } = useCoverageToolModalProvider();
  return (
    <button
      style={{
        position: 'absolute',
        top: 0,
        zIndex: 9999,
        backgroundColor: 'white',
        borderRadius: 5,
      }}
      onClick={printContext}
    >
      Print State
    </button>
  );
};

export default EnableDebug;
